import React from 'react';
import { Card } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import CardDropdown from 'components/common/CardDropdown';
import SalesTargetChart from './SalesTargetChart';
import { dealClosedVsGoalChart } from 'data/dashboard/crm';

const SalesTarget = () => {
  return (
    <Card className="h-100">
      <FalconCardHeader
        title="Sales Target"
        titleTag="h6"
        className="py-2"
        endEl={<CardDropdown />}
      />
      <Card.Body>
        <SalesTargetChart data={dealClosedVsGoalChart} />
      </Card.Body>
    </Card>
  );
};

export default SalesTarget;
